// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import av from './av.svg';

interface AvIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: AvNames;
}

export function AvIcon({ name, ...props }: AvIconProps) {
  return <Icon {...props} link={av} name={name} />
}

type AvNames =
  | '10k'
  | '1k_plus'
  | '1k'
  | '2k_plus'
  | '2k'
  | '3k_plus'
  | '3k'
  | '4k_plus'
  | '4k'
  | '5g'
  | '5k_plus'
  | '5k'
  | '6k_plus'
  | '6k'
  | '7k_plus'
  | '7k'
  | '8k_plus'
  | '8k'
  | '9k_plus'
  | '9k'
  | 'add_to_queue'
  | 'airplay'
  | 'album'
  | 'art_track'
  | 'audio_file'
  | 'av_timer'
  | 'branding_watermark'
  | 'call_to_action'
  | 'closed_caption_disabled'
  | 'closed_caption_off'
  | 'closed_caption'
  | 'control_camera'
  | 'equalizer'
  | 'explicit'
  | 'fast_forward'
  | 'fast_rewind'
  | 'featured_play_list'
  | 'featured_video'
  | 'fiber_dvr'
  | 'fiber_manual_record'
  | 'fiber_new'
  | 'fiber_pin'
  | 'fiber_smart_record'
  | 'forward_10'
  | 'forward_30'
  | 'forward_5'
  | 'games'
  | 'hd'
  | 'hearing_disabled'
  | 'hearing'
  | 'high_quality'
  | 'interpreter_mode'
  | 'library_add_check'
  | 'library_add'
  | 'library_books'
  | 'library_music'
  | 'loop'
  | 'lyrics'
  | 'mic_none'
  | 'mic_off'
  | 'mic'
  | 'missed_video_call'
  | 'movie'
  | 'music_video'
  | 'new_releases'
  | 'not_interested'
  | 'note'
  | 'pause_circle_filled'
  | 'pause_circle_outline'
  | 'pause_circle'
  | 'pause'
  | 'play_arrow'
  | 'play_circle_filled'
  | 'play_circle_outline'
  | 'play_circle'
  | 'play_disabled'
  | 'playlist_add_check_circle'
  | 'playlist_add_check'
  | 'playlist_add_circle'
  | 'playlist_add'
  | 'playlist_play'
  | 'playlist_remove'
  | 'queue_music'
  | 'queue_play_next'
  | 'queue'
  | 'radio'
  | 'recent_actors'
  | 'remove_from_queue'
  | 'repeat_on'
  | 'repeat_one_on'
  | 'repeat_one'
  | 'repeat'
  | 'replay_10'
  | 'replay_30'
  | 'replay_5'
  | 'replay_circle_filled'
  | 'replay'
  | 'sd'
  | 'shuffle_on'
  | 'shuffle'
  | 'skip_next'
  | 'skip_previous'
  | 'slow_motion_video'
  | 'snooze'
  | 'sort_by_alpha'
  | 'speed'
  | 'stop_circle'
  | 'stop'
  | 'subscriptions'
  | 'subtitles'
  | 'surround_sound'
  | 'video_call'
  | 'video_file'
  | 'video_label'
  | 'video_library'
  | 'video_settings'
  | 'videocam_off'
  | 'videocam'
  | 'volume_down'
  | 'volume_mute'
  | 'volume_off'
  | 'volume_up'
  | 'web_asset_off'
  | 'web_asset'
  | 'web'
;

